import { PagedApiResult } from "../../utilities/paged-request";
import { InvoiceRead } from "./invoice-read";
import { InvoiceTotals } from "../invoices/invoice-totals";

export class InvoiceSearchResponse {

    public searches : PagedApiResult<InvoiceRead>;
    public totals: InvoiceTotals;

}